import { useState } from 'react';

export function useCustomItemPicker() {
  const [customDesc, setCustomDesc] = useState('');
  const [customQty, setCustomQty] = useState(1);
  const [customPrice, setCustomPrice] = useState('');

  const reset = () => {
    setCustomDesc('');
    setCustomQty(1);
    setCustomPrice('');
  };

  const buildItem = () => {
    if (!customDesc.trim() || customPrice === '') return null;
    const price = parseFloat(customPrice);
    if (isNaN(price) || price < 0) return null;
    return {
      id: `custom-${Date.now()}`,
      isCustom: true,
      description: customDesc.trim(),
      quantity: customQty,
      unit_price: price,
    };
  };

  const handleAdd = (onAdd) => {
    const item = buildItem();
    if (!item) return;
    onAdd(item);
    reset();
  };

  const parsedPrice = parseFloat(customPrice);
  const isValid = customDesc.trim() !== '' && customPrice !== '' && !isNaN(parsedPrice) && parsedPrice >= 0;

  return {
    customDesc, setCustomDesc,
    customQty, setCustomQty,
    customPrice, setCustomPrice,
    handleAdd,
    isValid,
  };
}
